var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('label',{staticClass:"checkbox-container"},[_c('input',{attrs:{"type":"checkbox","id":_vm.name},domProps:{"value":_vm.checked},on:{"input":_vm.onChange}}),_c('span',{staticClass:"checkmark"})]),(_vm.label)?_c('label',{attrs:{"for":_vm.name}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }